import { render, staticRenderFns } from "./OtherSavingOptionsTelecoms.vue?vue&type=template&id=3f0ed07c&"
import script from "./OtherSavingOptionsTelecoms.vue?vue&type=script&lang=js&"
export * from "./OtherSavingOptionsTelecoms.vue?vue&type=script&lang=js&"
import style0 from "./OtherSavingOptionsTelecoms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports